import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { CANCEL, EDIT_LINK, PARTICIPANT_OBSERVATIONS, UPDATE } from "../../util/const";
import { useParticipant } from "../../services/useData";
import { HomePageProps } from "../PatientList";
import InfoCards from "../../Components/InfoCards";
import LinkPatient from "../LinkPatient";
import LinkObservations from "../LinkObservations";
import { Participant } from "../../types/participant";
import { DatabaseManager } from "../../services/DatabaseManager";
import { Observation } from "../../types/observation";
import { PatientContext } from "../ActivePatients";


const LinkEdit = (props:HomePageProps) =>
{
  const context = useContext(PatientContext);

  const fetchedData = useParticipant(context.patient.resourceId);
  const participant = fetchedData.participant;

  const [isChanging, setIsChanging] = useState(false);
  const [observations, setObservations] = useState<Array<Observation>>([]);

  const participantHasChanged = useRef(false);

  const participantChanged = (p: Participant) => {
    participantHasChanged.current = true;
    fetchedData.mutate(); // forces a change to participant so the useEffect is called again
  }

  const updateObservations = useCallback ((data: Observation[]) => {
    
    if(data.length === 0)
    {
      if(participantHasChanged.current)
      {
        props.toggleDisplay(true);
      }
    }
    else
    {
      data.forEach(element => {
        element.resourceId = context.patient.resourceId;
      });
      setObservations(data);
    }
    participantHasChanged.current = false;
  },[props, context.patient.resourceId]);

  const loadObservations = useCallback((documentId: string) => {

    if(documentId === undefined || documentId.length === 0)
      return;
    
    DatabaseManager.getInstance()
      .get(PARTICIPANT_OBSERVATIONS + "/" + documentId)
      .then((response) => {
        if(response.data)
          updateObservations(response.data as Observation[]);
      })
      .catch(() => {
        console.log("fetch link observation error");
      });
  },[updateObservations]);

  useEffect(() => {
    if(participant !== undefined)
      loadObservations(participant.documentId);
  }, [participant, loadObservations]);

  const actionButton = () => {
    if(!isChanging) {
      return (<Button
        type="button"
        onClick={(e) => setIsChanging(!isChanging) }
        className="fs-6 btn-outline-white">
        {UPDATE}
      </Button>);
    }
  }

  const onButtonClick = (cancellAll: boolean) => {
    if(cancellAll)
      props.toggleDisplay(true);
    else
    {
      if(isChanging) setIsChanging(!isChanging);
      else props.toggleDisplay(false);
    }
  }

  return (
    <Card className="mt-3 mb-3" border="secondary" text="white">
      <Card.Header className="fs-6 app-colour">
        <Row>
          <Col>{EDIT_LINK}</Col>
          <Col className="right">
            <Button
              type="button"
              onClick={(e) => isChanging ? onButtonClick(true) : onButtonClick(false)}
              className="fs-6 btn-outline-white me-2">
              {CANCEL}
            </Button>
            { actionButton() }
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="color-text fs-6">
        { isChanging ? <LinkPatient toggleDisplay={onButtonClick} participantChanged={participantChanged}/> :
          participant === undefined ? (<></>): 
          (
            <>
            <InfoCards participant={participant} patient={context.patient} />
            <LinkObservations toggleDisplay={onButtonClick} participant={participant} observations={observations}/>
            </>      
          )
        }
      </Card.Body>
    </Card>
  );
}

export default LinkEdit;